var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',_vm._b({staticClass:"um-image"},'el-image',_vm.$attrs,false),[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_c('i',{staticClass:"el-icon-picture"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }